import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "question-green-bgr p-3"
}
const _hoisted_2 = { class: "d-flex flex-wrap align-center result-question p-0" }
const _hoisted_3 = { class: "flex-grow-1 text-sm-start" }
const _hoisted_4 = { class: "title flex-nowrap" }
const _hoisted_5 = { class: "caption" }
const _hoisted_6 = { class: "flex-shrink-0 text-center" }
const _hoisted_7 = {
  key: 1,
  class: "d-flex question-green-bgr p-3"
}
const _hoisted_8 = { class: "skill-full-width" }
const _hoisted_9 = { class: "skill-td-left" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "caption" }
const _hoisted_12 = { class: "text-xs-right skill-td-right" }

import { computed } from 'vue'
import SlideBar from './SlideBar.vue'
import ChartProgress from './ChartProgress.vue'
import { LETTER_FORMAT } from '../../utils/constants'
import Skill from '../../models/skill'
import UserExam from '../../models/user_exam'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'ExamSkillReport',
  props: {
    skill: {},
    userExam: {},
    mobile: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

// Computed
const skillAverage = computed(() => {
  if (props.skill.skillItems.length === 0) {
    return 0
  }

  const result = props.skill.skillItems.reduce((total, item) => total + Number(item.averageScore), 0)
  return Math.round((result * 10) / props.skill.skillItems.length) / 10
})

const skillScore = computed(() => props.skill.getSkillScore(props.userExam))

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (!__props.mobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_container, { class: "p-2" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.skill.name), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_5, _toDisplayString(__props.skill.skillItems.length) + " " + _toDisplayString(_ctx.$t('exam_result.skill_items', { format: _unref(LETTER_FORMAT).UPTITLECASE })) + ", " + _toDisplayString(skillAverage.value) + "% " + _toDisplayString(_ctx.$t('exam_result.average_point', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(ChartProgress, {
                  size: 160,
                  series: [skillScore.value],
                  labelColor: '#666666',
                  label: skillScore.value.toString(),
                  subLabel: "%",
                  chartColor: skillScore.value >= skillAverage.value ? '#2699fb' : '#f44337',
                  trackColor: '#ffffff',
                  fontSizeLabel: '13px',
                  fontSizeValue: '24px',
                  labelOffsetY: 5,
                  subLabelOffsetY: 5,
                  trackOpacity: 1
                }, null, 8 /* PROPS */, ["series", "label", "chartColor"])
              ])
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(__props.skill.name), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_11, _toDisplayString(__props.skill.skillItems.length) + " " + _toDisplayString(_ctx.$t('exam_result.skill_items', { format: _unref(LETTER_FORMAT).UPTITLECASE })) + ", " + _toDisplayString(skillAverage.value) + "% " + _toDisplayString(_ctx.$t('exam_result.average_point', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
              ]),
              _createElementVNode("td", _hoisted_12, [
                _createVNode(ChartProgress, {
                  size: 160,
                  series: [skillScore.value],
                  labelColor: '#666666',
                  label: skillScore.value.toString(),
                  subLabel: "%",
                  chartColor: skillScore.value >= skillAverage.value ? '#2699fb' : '#f44337',
                  trackColor: '#ffffff',
                  fontSizeLabel: '13px',
                  fontSizeValue: '24px',
                  labelOffsetY: 5,
                  subLabelOffsetY: 5,
                  trackOpacity: 1
                }, null, 8 /* PROPS */, ["series", "label", "chartColor"])
              ])
            ])
          ])
        ])
      ]))
}
}

})